import React from 'react';
import classes from './ReferFriendTile.module.scss';

import A from '../../atoms/A/A';
import Oinq from 'components/assets/oinq/oinq_success.svg';
import { REFER } from '../pages';
import Txt from '../../atoms/Txt/Txt';

export interface Props {
  currencySymbol: string;
}

const ReferFriendTile: React.FC<Props> = ({ currencySymbol }) => {
  return (
    <A to={REFER.path} className={classes.root}>
      <div className={classes.tile}>
        <Txt component="h3" className={classes.title}>
          Want to earn an easy <strong>{currencySymbol}1?</strong>
        </Txt>
        <Oinq className={classes.oinq} />
        <Txt component="span" className={classes.button}>
          Refer a Friend
        </Txt>
      </div>
    </A>
  );
};

export default ReferFriendTile;
